/** Customer-facing language for parent bedtime surfaces.
 * API and storage names intentionally remain unchanged.
 */
export function familyVoicePhrase(name?: string | null): string {
  const value = name?.trim();
  if (!value) return 'a Family voice';
  return /\bvoice$/i.test(value) ? value : `${value}’s voice`;
}

export function familyVoiceStatus(status: string, consentActive?: boolean | null, sampleCount?: number | null): string {
  if (status === 'failed') return 'Needs attention';
  if (status === 'ready' && consentActive === true) return 'Ready';
  if (consentActive === false) return 'Needs consent';
  if (status === 'ready') return 'Needs consent';
  if (status === 'training') return 'Making voice';
  if (status === 'processing' && sampleCount === 0) return 'Recording needed';
  if (status === 'processing') return 'Recording in progress';
  return 'Not ready';
}

export const parentTerms = {
  familyVoice: 'Family voice',
  storyteller: 'Storyteller',
  record: 'Record',
  recording: 'Recording',
  prepare: 'Prepare',
  buildingVoice: 'Making voice',
  storyMode: 'Story mode',
  listener: 'Listener',
} as const;
